import React, { FC } from "react";

export const TrustPilotFourStars: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="122" height="23" fill="none">
    <path fill="#73CF11" d="M0 0h22.593v22.593H0z" />
    <path
      fill="#fff"
      d="m11.296 15.449 3.436-.92 1.436 4.674-4.872-3.754Zm7.908-6.043h-6.049L11.296 3.39 9.437 9.406H3.39l4.895 3.73-1.86 6.018 4.896-3.73 3.012-2.288 4.872-3.73Z"
    />
    <path fill="#73CF11" d="M24.852 0h22.593v22.593H24.852z" />
    <path
      fill="#fff"
      d="m36.148 15.449 3.436-.92 1.436 4.674-4.872-3.754Zm7.907-6.043h-6.048L36.148 3.39l-1.86 6.017h-6.047l4.895 3.73-1.86 6.018 4.896-3.73 3.012-2.288 4.872-3.73Z"
    />
    <path fill="#73CF11" d="M49.704 0h22.593v22.593H49.704z" />
    <path
      fill="#fff"
      d="m61 15.449 3.436-.92 1.435 4.674L61 15.45Zm7.907-6.043H62.86L61 3.39l-1.86 6.017h-6.047l4.895 3.73-1.86 6.018 4.895-3.73 3.013-2.288 4.871-3.73Z"
    />
    <path fill="#73CF11" d="M74.555 0h22.593v22.593H74.555z" />
    <path
      fill="#fff"
      d="m85.852 15.449 3.436-.92 1.435 4.674-4.871-3.754Zm7.907-6.043h-6.048l-1.86-6.017-1.858 6.017h-6.048l4.895 3.73-1.86 6.018 4.895-3.73 3.013-2.288 4.871-3.73Z"
    />
    <path fill="#D9D9D9" d="M99.407 0H122v22.593H99.407z" />
    <path
      fill="#fff"
      d="m110.704 15.449 3.436-.92 1.435 4.674-4.871-3.754Zm7.907-6.043h-6.048l-1.859-6.017-1.86 6.017h-6.048l4.895 3.73-1.859 6.018 4.895-3.73 3.013-2.288 4.871-3.73Z"
    />
  </svg>
);
